import React from "react";
import { AccessTime, CameraOutlined, Dashboard, Folder as FolderIcon, Share, StarBorder } from "@mui/icons-material";

import { SearchScope } from "./useSearchScope";

export const getScopeIcon = (scope: SearchScope): React.ReactElement => {
  const sx = { fontSize: 16, color: "secondary.main" };
  switch (scope.type) {
    case "workspace":
      return <Dashboard sx={sx} />;
    case "recent":
      return <AccessTime sx={sx} />;
    case "shared":
      return <Share sx={sx} />;
    case "starred":
      return <StarBorder sx={sx} />;
    case "market_lens":
      return <CameraOutlined sx={sx} />;
    default:
      return <FolderIcon sx={sx} />;
  }
};

export const getScopeLabel = (scope: SearchScope): string => {
  if (scope.type === "workspace") return "Workspace";
  if (scope.type === "recent") return "Recent";
  if (scope.type === "shared") return "Shared with me";
  if (scope.type === "starred") return "Starred";
  if (scope.type === "market_lens") return scope.folderName ?? "Market Lens";
  return scope.folderName ?? "Folder";
};
